import React from "react";
import "./money.css";
import useDBO from "../../../hooks/useDBO";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";
import VND from "../../../components/VND";
import SLink from "../../../components/SLink";
import Lang from "../../../components/Lang";
/* import ScreenReceipt from "../../student/components/ScreenReceipt"; */
import Staff from "../../../components/Staff";
import Time from "../../../components/Time";
import { usePrimaryColor } from "../../../components/PrimaryColorContext";


/**
 * Payments list component.
 * Displays a list of payment records with totals.
 * Uses flat premium design language with Tailwind utilities.
 *
 * @param {Object} props - Component props
 * @param {Array} props.payments - Array of payment records
 * @param {number} props.paymentType - Payment type filter
 * @returns {JSX.Element} Payments section with list and total
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
export default function Payments({ payments }) {
  const { primaryColor } = usePrimaryColor();

    return (
      <div className="money-outline" style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
        <div className="money-subtitle">
          <Lang w="payments" />
        </div>
        {payments.map((p, i) => (
          <DrawPayment
            payment={p}
            i={i}
            key={p._id}
          />
        ))}
        <div className="flex justify-between items-center mt-3 pt-3 border-t-2 border-slate-200">
          <div className="text-[0.8rem] font-extrabold text-slate-700 uppercase tracking-tight">
            <Lang w="total" />
          </div>
          <div className="text-[0.85rem] font-extrabold" >
            <VND value={payments.reduce((a, b) => a + b.amount, 0)} />
          </div>
        </div>
      </div>
    );
}

/**
 * Single payment row component.
 * Displays student links, amount, cashier, and timestamp.
 *
 * @param {Object} props - Component props
 * @param {Object} props.payment - Payment record
 * @param {number} props.i - Index for keying
 * @returns {JSX.Element} Payment row
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
function DrawPayment({ payment }) {

    const tuition = payment.bills.filter(b=>b.billType==="Tuition")
    return (
      <div className="flex justify-between items-start py-3 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/50 -mx-2 px-2 rounded-lg transition-colors">
        <div>
          {payment.students.map((s) => <StudentAndTuition student={s} payment={payment} key={s} />)}
        </div>
        <div className="text-right shrink-0 ml-4">
          <div className="text-[0.85rem] font-bold text-slate-800">
            <VND value={payment.amount} />
          </div>
          <div className="text-[0.65rem] text-slate-400 mt-0.5 font-medium">
            <Staff id={payment.cashier} />
            <span className="ml-1">{new Date(payment.createdAt).fTime()}</span>
          </div>
        </div>
      </div>
    );
}

/**
 * Student link with tuition info component.
 * Renders a link to the student and their tuition details if available.
 *
 * @param {Object} props - Component props
 * @param {string} props.student - Student ID
 * @param {Object} props.payment - Payment record containing bills
 * @returns {JSX.Element} Student link with optional tuition breakdown
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
function StudentAndTuition({ payment, student }) {

  const tuition = payment.bills.find(b=>b.student === student && b.billType==="Tuition")

   return <div>
            <SLink
              id={student}
              tab="bills"
              key={student}
              />
     {tuition && <div>
       <div className="text-[0.7rem] text-slate-400 mt-0.5">{tuition.description}</div>
       <div className="text-[0.7rem] text-slate-400"><VND value={tuition.costPerLessonReal} /> / lesson </div>
     </div>}
     </div>

}